
  import info from "@/components/_universal/list-info.vue";
  import tablelist from "@/components/_universal/list-table.vue";

  // Standard Components
  import EVENTS from "@/constants/events";

  // Controller
  import InventoryController from "@/controllers/inventory-controller";
  import listMixin from "@/mixin/list-mixin";

  // Initialize the controller (reuse the same instance)
  const inventoryController = new InventoryController();

  export default {
    mixins: [listMixin],
    data() {
      return {
        listDataObj: {},
        EVENT_ACTION: {},
        project: {},
        timer: null,         // Holds the interval timer ID.
        apiCallCount: 0,     // Tracks the total number of API calls.
        unsubscribe: null,   // Holds the Vuex subscription function.
      };
    },
    methods: {
      async onFilterChange() {
        // Get the current filter from the store (if available)
        if (this.$store.getters.getList.filter) {
          this.filter = this.$store.getters.getList.filter;
        }
        // Call the API using the controller and update the store.
        let data = await inventoryController.getListResults(this.filter);
        await this.updateResults(data.resources);
      },
      async loadData() {
        // Load the initial list data via the controller.
        this.listDataObj = await inventoryController.list();
        // Update the store if data retrieval was successful.
        if (this.listDataObj.table.data.success) {
          this.updateResults(this.listDataObj.table.data.resources);
        }
      },
      async updateResults(results) {
        // Dispatch new list data to the Vuex store.
        this.$store.dispatch("setList", results);
      },
      subscribeOnFilterChange() {
        // Subscribe to filter changes in the store.
        this.unsubscribe = this.$store.subscribe((mutation, state) => {
          if (mutation.type === "setFilter") {
            this.onFilterChange();
          }
        });
      },
    },
    components: {
      info,
      tablelist,
    },
    async mounted() {
      // Subscribe to filter changes.
      this.subscribeOnFilterChange();
      // Set up an interval to call onFilterChange() every 20 seconds.
      this.timer = setInterval(async () => {
        // If 30 API calls have been made, clear the timer.
        if (this.apiCallCount >= 30) {
          clearInterval(this.timer);
          this.timer = null;
          
          return;
        }
        await this.onFilterChange();
        this.apiCallCount++;
        
      }, 20000);
    },
    async created() {
      // Import event constants.
      this.EVENT_ACTION = EVENTS;
      // Load the initial data.
      await this.loadData();
    },
    beforeDestroy() {
      // Clean up: reset store data.
      this.updateResults(null);
      // Unsubscribe from store changes.
      if (this.unsubscribe) {
        this.unsubscribe();
      }
      // Clear the timer if it exists.
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
  };
